import LogService from "../../middleware/CommonSdk/LogService";

export const ConvertUrlAddRefPrefix = "addedref:";

const LOG_TAG = "PATH_UTILS";

export const convertToUrl = (uriString) => {
    let url = uriString;

    if (uriString.match(/^http(s)?:\/\//) == null)
        url = ConvertUrlAddRefPrefix + uriString;

    try {
        url = new URL(url);
    } catch (error) {
        LogService.error(LOG_TAG, "convertToUrl error", error);
    }

    return url;
}

// encodeURI() will not encode: ~!@#$&*()=:/,;?+'
// encodeURIComponent() will not encode: ~!*()'
// for usage : https://javascript.info/url
export const addOrUpdateQueryParameterToPathString = (pathString, key, value) => {
    let convertedUrl = convertToUrl(pathString);
    if (convertedUrl) {
        const searchParam = new URLSearchParams(convertedUrl.search);
        // const p = new URLSearchParams([['a', ''], ['b', 'non-empty', ['c', '']]);//autre syntax
        // const searchParams = new URLSearchParams(`bin=${base64Data}`); // 
        searchParam.delete(key);
        if (typeof value === "string" && value.length > 0) {
            searchParam.append(key, value);
        } else if (typeof value === "boolean" || typeof value === "number") {
            searchParam.append(key, value);
        }
        convertedUrl.search = [...searchParam.entries()].map(entry => entry.map(encodeURIComponent).join("=")).join("&"); //? is added on affectation to convertedUrl.search
    }
    return convertedUrl.pathname + convertedUrl.search;
}

export const hasQueryParameterInPathString = (pathString, key) => {
    let hasParameter = false;

    if (pathString) {
        const searchParam = new URLSearchParams(pathString);
        hasParameter = searchParam.has(key);
    }
    return hasParameter;
}

export const getQueryParameterInPathString = (pathString, key) => {
    let value = null;

    if (pathString) {
        const searchParam = new URLSearchParams(pathString);
        value = searchParam.get(key);
    }
    return value;
}
